"use client";

import React from "react";
import styled from "styled-components";
import FilterContainer from "../../../UI/FilterContainer/FilterContainer";

import IconShield from "@lmn/lastminute-react-icons/icons-converted/lastminute-icons-solid/IconShield.js";
import SpecialDealsFilter from "../ASN/SpecialDealsFilter/SpecialDealsFilter";
import FlexibleCancellationFilter from "../ASN/FlexibleCancellationFilter/FlexibleCancellationFilter";
import HotelCriteriaFilter from "../ASN/HotelCriteriaFilter/HotelCriteriaFilter";
import MealTypeFilter from "../ASN/MealTypeFilter/MealTypeFilter";
import RoomTypeFilter from "../ASN/RoomTypeFilter/RoomTypeFilter";
import TransferFilter from "../ASN/TransferFilter/TransferFilter";
import StarsFilter from "../ASN/StarsFilter/StarsFilter";
import RecommendationFilter from "../ASN/RecommendationFilter/RecommendationFilter";
import HolidayTypesFilter from "../ASN/HolidayTypesFilter/HolidayTypesFilter";
import PriceFilter from "../ASN/PriceFilter/PriceFilter";
import TourOperatorFilter from "../ASN/TourOperatorFilter/TourOperatorFilter";
import AirlineFilter from "../ASN/AirlineFilter/AirlineFilter";
import RentalCarFilter from "@/components/Stateful/Filters/ASN/TransferFilter/RentalCarFilter";
import AdSlot from "../../../../lib/AdManagment/AdSlot";
import BookOnOptionFilter from "@/components/Stateful/Filters/ASN/BookOnOptionFilter/BookOnOptionFilter";
import { AppConfig } from "@/lib/Types/AppConfig";

const StyledFilterPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 420px;
  margin: 0 auto;
  width: 100%;
`;

const AdSideContaner = styled.div`
  margin-top: 1rem;
  &:empty {
    display: none;
  }
`;

export interface FilterPanelProps {
  appConfig: AppConfig;
  hasSpecialDealsFilter?: boolean;
  hasFlexibleCancellation?: boolean;
  delayedUpdate?: boolean;
  hasBannerGpt?: boolean;
  isDestinationPage?: boolean;
  isHotelDetailPage?: boolean;
  isHotelOnly?: boolean;
}

const FilterPanel: React.FC<FilterPanelProps> = ({
  appConfig,
  hasSpecialDealsFilter = false,
  hasFlexibleCancellation = false,
  delayedUpdate = false,
  hasBannerGpt = false,
  isDestinationPage = false,
  isHotelDetailPage = false,
  isHotelOnly = false,
}) => {
  const BOOKONOPTION_ENABLED = true

  return (
    <>
      <StyledFilterPanel>
        {hasSpecialDealsFilter && (
          <FilterContainer title="Deals">
            <SpecialDealsFilter delayedUpdate={delayedUpdate} />
          </FilterContainer>
        )}

        {!isDestinationPage && (hasFlexibleCancellation || BOOKONOPTION_ENABLED) && (
          <FilterContainer
            title="Sorgenfrei buchen"
            icon={<IconShield size={16} />}
          >
            {hasFlexibleCancellation && (
              <FlexibleCancellationFilter delayedUpdate={delayedUpdate} />
            )}
            {BOOKONOPTION_ENABLED && (<BookOnOptionFilter delayedUpdate={delayedUpdate} />)}
          </FilterContainer>
        )}

        {!isHotelDetailPage && (
          <FilterContainer title="Häufig verwendete Filter">
            <HotelCriteriaFilter delayedUpdate={delayedUpdate} />
          </FilterContainer>
        )}

        <FilterContainer title="Verpflegung">
          <MealTypeFilter delayedUpdate={delayedUpdate} />
        </FilterContainer>

        <FilterContainer title="Zimmer">
          <RoomTypeFilter
            delayedUpdate={delayedUpdate}
            isHotelOnly={isHotelOnly}
          />
        </FilterContainer>

        {!isHotelOnly && (
          <FilterContainer title="Flug & Transfer">
            <TransferFilter
              delayedUpdate={delayedUpdate}
              isHotelDetailPage={isHotelDetailPage}
            />
            {!isDestinationPage && (
              <AirlineFilter
                delayedUpdate={delayedUpdate}
                appConfig={appConfig}
              />
            )}
          </FilterContainer>
        )}

        {!isHotelDetailPage && (
          <FilterContainer title="Hotelkategorie ab">
            <StarsFilter delayedUpdate={delayedUpdate} />
          </FilterContainer>
        )}
        <FilterContainer title="Gesamtpreis">
          <PriceFilter delayedUpdate={delayedUpdate} />
        </FilterContainer>

        {!isHotelDetailPage && (
          <FilterContainer title="Weiterempfehlungsrate ab">
            <RecommendationFilter delayedUpdate={delayedUpdate} />
          </FilterContainer>
        )}
        {!isHotelDetailPage && (
          <FilterContainer title="Urlaubsarten">
            <HolidayTypesFilter delayedUpdate={delayedUpdate} />
          </FilterContainer>
        )}

        <FilterContainer title="Reiseveranstalter">
          <TourOperatorFilter
            delayedUpdate={delayedUpdate}
            appConfig={appConfig}
          />
        </FilterContainer>

        {isHotelOnly && <RentalCarFilter delayedUpdate={delayedUpdate} />}

      </StyledFilterPanel>


      {hasBannerGpt && (
        <AdSideContaner>
          <AdSlot slotId="afscontainer1" />
          <AdSlot slotId="div-gpt-ad-external_right" />
        </AdSideContaner>
      )}
    </>
  );
};

export default FilterPanel;
